import { getBasePath } from "@/models/utils";
import { useRouter } from "@/_router";
import { useAuth } from "@/models/useAuth";
import { useEffect } from "react";
import { useUserSlice } from "@/models/useUserSlice";

export default function AuthPage() {
  const router = useRouter();
  const urlParams = new URLSearchParams(window.location.search);
  const guestToken = urlParams.get("guestToken");
  const noteId = urlParams.get("noteId");
  const action = urlParams.get("action");
  const redirectUrl = urlParams.get("redirectUrl");

  useEffect(() => {
    useUserSlice
      .getState()
      .user()
      .remoteConfig({
        callback: (config) => {
          useUserSlice.getState().setWebSubscriptionPlans(config.webPlans);
          useUserSlice.getState().setCountry(config.country);
        },
      });

    useAuth.signIn({
      forceSignIn: true,
      callback: async () => {
        if (guestToken && noteId) {
        } else if (redirectUrl) {
          router.replace(redirectUrl);
        } else {
          router.push(`${getBasePath()}/home`);
        }
      },
    });
  }, []);

  return <div />;
}
